const ComplexSkeleton: React.FC<any> = ({ viewRef }) => {
  return (
    <div className="overflow-hidden my-5" ref={viewRef}>
      <div className="flex justify-between items-center px-5">
        <div className="inline-flex flex-col mb-[10px]">
          <div className="inline-block h-5 leading-8 w-20 rounded-700 skeleton mb-[6px]" />
          <div className="inline-block h-4 leading-8 w-[220px] rounded-700 skeleton mb-[6px]" />
          <div className="inline-block h-4 leading-8 w-[220px] rounded-700 skeleton" />
        </div>
        <div className="w-[50px] h-[50px] rounded-full skeleton"></div>
      </div>
      <div className="mt-[5px] px-5">
        <div className="mb-[6px] h-4 leading-6 rounded-700 skeleton" />
        <div className="mb-[6px] h-4 leading-6 rounded-700 skeleton" />
        <div className="mb-[6px] h-4 leading-6 rounded-700 skeleton" />
      </div>
    </div>
  );
};

export default ComplexSkeleton;
